// An intake item (data-model.md "intake_items"; shift-engine §6).
//
// The unit every lane produces. `payload` is untrusted by construction (an end user's
// report, a crash blob, a voice note) and lives behind the injection wall
// (instrumentation-and-ingest §8); it is DATA, never an instruction. Tenant-scoped by
// `accountId` with row-level security in the db lane.
import { z } from "zod";
import { AccountId, AppId, IntakeItemId } from "../ids.js";
import { JsonObject, Timestamp } from "./common.js";
import { IntakeLane, IntakeStatus, Sentiment, SourceClass } from "./enums.js";
export const IntakeItem = z.object({
    id: IntakeItemId,
    accountId: AccountId,
    appId: AppId,
    lane: IntakeLane,
    sourceClass: SourceClass,
    /** The lane-specific payload (jsonb). Untrusted; analyzed, never executed. */
    payload: JsonObject,
    /** Coarse sentiment; null until classified. */
    sentiment: Sentiment.nullable(),
    /** The feedback theme this item clustered into (feedback_themes.id); null until clustered. */
    themeId: z.uuid().nullable(),
    status: IntakeStatus,
    createdAt: Timestamp,
});
//# sourceMappingURL=intake-item.js.map